/**
 * `trackEvent` — the original's module 19990 export `B`.
 *
 * One call fans out to every tag the app carries: the Facebook Pixel, then the
 * analytics provider, then Google Tag Manager's `dataLayer`. Each arm is
 * individually optional, so on a build with no ids configured (which is what we
 * ship — see `Analytics.tsx`) every call is a silent no-op.
 *
 * Deviation, recorded deliberately: the original's middle arm is Firebase
 * Analytics `logEvent`. This reconstruction has no Firebase SDK — `Analytics.tsx`
 * reproduces GTM, Clarity and the Pixel only — so that arm is absent rather
 * than faked against a different project.
 */

type EventParams = Record<string, unknown>;

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    dataLayer?: EventParams[];
  }
}

const pushToDataLayer = (event: string, params?: EventParams): void => {
  if (typeof window === "undefined" || !window.dataLayer) return;
  window.dataLayer.push({ event, ...params });
};

/** `o` (`t`) — the page-view event, fired once per route. */
export const trackPageView = (): void => {
  if (typeof window === "undefined") return;
  window.fbq?.("track", "PageView");
  pushToDataLayer("PageView");
};

/** `a` (`B`) — a named event, e.g. `trackEvent("Contact")`. */
export const trackEvent = (event: string, params?: EventParams): void => {
  if (typeof window === "undefined") return;
  window.fbq?.("track", event, params);
  pushToDataLayer(event, params);
};
